// Chess sound effects with lazy loading
let moveSound = null;
let captureSound = null;
let checkSound = null;
let successSound = null;
let errorSound = null;

const loadSound = (path) => {
  try {
    const audio = new Audio(process.env.PUBLIC_URL + path);
    audio.load();
    return audio;
  } catch (err) {
    console.error('Error loading sound:', path, err);
    return null;
  }
};

const initSounds = () => {
  if (!moveSound) moveSound = loadSound('/sounds/move.mp3');
  if (!captureSound) captureSound = loadSound('/sounds/capture.mp3');
  if (!checkSound) checkSound = loadSound('/sounds/check.wav');
  if (!successSound) successSound = loadSound('/sounds/success.mp3');
  if (!errorSound) errorSound = loadSound('/sounds/Error.mp3');
};

const playSound = (sound) => {
  if (!sound) return;
  if (localStorage.getItem('chessSoundsMuted') === 'true') return;
  sound.currentTime = 0;
  sound.play().catch(err => console.error('Error playing sound:', err));
};

export const playMoveSound = () => {
  initSounds();
  playSound(moveSound);
};

export const playCaptureSound = () => {
  initSounds();
  playSound(captureSound);
};

export const playCheckSound = () => {
  initSounds();
  playSound(checkSound);
};

export const playCastleSound = () => {
  initSounds();
  playSound(moveSound); // Using move sound for castling
};

export const playSuccessSound = () => {
  initSounds();
  playSound(successSound);
};

export const playErrorSound = () => {
  initSounds();
  playSound(errorSound);
};
